import React from 'react';

import { EventArea } from '../../../../analytics-library/entry/sendEvent';
import { getActionType } from '../../../../sharedModules/getActionType';
import { getDealImage } from '../../../modules/getDealImage';
import { useHawkWidgetContext } from '../HawkWidget/HawkWidgetContext';

import type { DealImageProps } from './model';

const DealImage: React.FC<DealImageProps> = ({
  deal,
  className,
  priority,
  width,
  height,
  useViewSimilarPriorityFilter = true,
}) => {
  const { url, alt, type } = getDealImage(deal, priority, width, useViewSimilarPriorityFilter);
  const {
    articleUrl,
    genericSharedComponents: { AffiliateLink, LazyImage },
  } = useHawkWidgetContext();

  const isLogo = ['merchant', 'network'].includes(type);

  return (
    <AffiliateLink
      deal={deal}
      className={className}
      actionType={getActionType({
        link: deal.offer.link,
        articleUrl,
        productType: deal.product_type,
      })}
      areaClicked={isLogo ? EventArea.RETAILER_IMAGE : EventArea.PRODUCT_IMAGE}
    >
      <LazyImage
        src={url}
        alt={alt}
        width={width || (isLogo ? 80 : 78)}
        height={height || (isLogo ? 40 : 70)}
        className={className ?? (isLogo ? 'logo-image' : 'product-image')}
      />
    </AffiliateLink>
  );
};

export default DealImage;
